import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { SITE_URL } from "./site-config";

export type Crumb = { label: string; href?: string };

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="mx-auto max-w-7xl px-4 pt-4 pb-2 text-sm">
      <ol className="flex flex-wrap items-center gap-1 text-muted-foreground">
        <li>
          <Link to="/" className="hover:text-brand hover:underline">Home</Link>
        </li>
        {items.map((c, i) => (
          <li key={i} className="flex items-center gap-1">
            <ChevronRight className="size-3.5 opacity-60" aria-hidden="true" />
            {c.href && i < items.length - 1 ? (
              <Link to={c.href} className="hover:text-brand hover:underline">{c.label}</Link>
            ) : (
              <span className="text-foreground font-medium" aria-current="page">{c.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export function breadcrumbListJsonLd(items: Crumb[]): Record<string, unknown> {
  const list = [{ name: "Home", url: SITE_URL + "/" }, ...items.map(c => ({
    name: c.label,
    url: c.href ? SITE_URL + c.href : undefined,
  }))];
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: list.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      ...(it.url ? { item: it.url } : {}),
    })),
  };
}
